import React from "react";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { setElement } from "utils/Utils";
import { MultiSelectField } from "../FieldService";
import {
	InformationRight,
	ReportFieldRights
} from "core/blueprint/trajectory/TrajectoryBlueprintService";

export type MultiSelectInputProps = {
	field: MultiSelectField;
	rights: ReportFieldRights;
	editable: boolean;
	onChange: (uuid: string, value: string) => void;
};

const MultiSelectInput: React.FC<MultiSelectInputProps> = (
	props: MultiSelectInputProps
) => {
	function isValid(value: string): boolean {
		return props.field.required ? props.field.value.length > 0 : true;
	}

	function setValue(option: string, checked: boolean): void {
		const newValue = setElement(checked, option, props.field.value);
		props.onChange(props.field.uuid, JSON.stringify(newValue));
	}

	function toId(uuid: string): string {
		const separatorIndex = uuid.indexOf("#");
		return separatorIndex === -1 ? uuid : uuid.substring(0, separatorIndex);
	}

	return (
		<Grid item>
			<Typography>{props.field.name}</Typography>
			<FormGroup row>
				{props.field.options.map(option => (
					<FormControlLabel
						key={option.value}
						control={
							<Checkbox
								checked={props.field.value.includes(
									option.value
								)}
								disabled={
									!props.editable ||
									props.rights[toId(props.field.uuid)][
										InformationRight.WRITE
									] === false
								}
								onChange={(event, checked): void => {
									setValue(option.value, checked);
								}}
							/>
						}
						label={option.value}
					/>
				))}
			</FormGroup>
		</Grid>
	);
};

export default MultiSelectInput;
